import $ from 'jquery'

export const createEvent = (name: string): Event => {
  return new Event(name)
}

export const escapeCssSelector = (id: string): string => {
  // Check if CSS.escape is available and use it if it is.
  if (typeof CSS !== 'undefined' && CSS.escape) {
    return CSS.escape(id)
  }

  // Fallback for environments where CSS.escape is not available.
  // This handles a subset of scenarios such as leading numbers and special characters.
  return id.replace(/([^\w-])/g, '\\$1').replace(/^(\d)/, '\\3$1 ')
}

export const InputEvent = (): Event => createEvent('input')

export const makeMeSticky = (selector: string, top: number): void => {
  $(selector).css({ position: 'sticky', top: `${top}px` })
}

export const isVisible = (element: HTMLElement): boolean => {
  if (!element) return false

  // This solution was used in jQuery:visible
  return !!(
    element.offsetWidth ||
    element.offsetHeight ||
    element.getClientRects().length
  )
}

export const getScrollbarWidth = (element: HTMLElement): boolean | number => {
  if (!element) {
    return false
  }

  return element.offsetWidth - element.clientWidth
}

export const _scrollTo = (
  elementSelector: string,
  container = 'html'
): Promise<void> => {
  return new Promise(function (resolve) {
    setTimeout(() => {
      const element = $(elementSelector)[0]
      if (element) {
        const scrollTop =
          ($(container).scrollTop() as number) +
          ($(element).offset()?.top || 0) -
          80 -
          ($(window).scrollTop() || 0)

        $(container).animate({ scrollTop: scrollTop }, 300)
        resolve()
      }
    }, 50)
  })
}

export const scrollToElement = (
  elementSelector: string,
  distance: ScrollLogicalPosition = 'center'
): void => {
  const element = document.querySelector(elementSelector)
  if (element) element.scrollIntoView({ behavior: 'smooth', block: distance })
}

export const waitForElement = (
  doc: Document,
  selector: string
): Promise<HTMLElement> => {
  return new Promise((resolve) => {
    const elm = doc.querySelector(selector) as HTMLElement

    if (elm) {
      return resolve(elm)
    }

    const observer = new MutationObserver(() => {
      const elm = doc.querySelector(selector) as HTMLElement

      if (elm) {
        resolve(elm)
        observer.disconnect()
      }
    })

    observer.observe(doc.body, {
      childList: true,
      subtree: true,
    })
  })
}

/**
 * Get the navbar height, adds an offset in case the body does not have a no-body-padding class
 * The body top padding can change dynamically on page resizes.
 * @returns {<number>} - The integer height for the total navbar height
 */
export const getNavbarHeight = (): number => {
  const navbar = document.querySelector(
    '[data-role=navbar-height]'
  ) as HTMLElement

  const offset = document.body.classList.contains('no-body-padding') ? 0 : 20
  const navbarHeight = navbar ? navbar.offsetHeight : 0

  return navbarHeight + offset
}

export * from './jquery-alternatives'
